import React from "react";
import playStore from "../../assets/images/googleplay.webp";
import appStore from "../../assets/images/appstore.png";


export default function DownloadAppSection() {
  return (
    <div className="flex flex-col md:flex-row items-center justify-center bg-gradient-to-r from-white to-blue-100 py-16 md:py-24 px-4 md:px-16 min-h-[60vh] gap-10">
      
    
      <div className="w-full md:w-1/2 max-w-md">
        <div className="bg-white/90 border border-blue-50 rounded-3xl p-8 shadow-lg h-full flex flex-col justify-between">
          <div>
            <h2 className="text-xl md:text-4xl font-extrabold text-[#7b003f] mb-2 tracking-tight text-center">
              <span className="italic text-[#5c1a32]">Get it on</span>{" "}
              <span className="text-[#7b003f]">Google Play Store</span>
            </h2>
            <span className="inline-block text-xs font-bold bg-[#fde3ff] text-[#82045a] rounded-xl py-1 px-3 mt-2 mb-6">
              Available Now
            </span>
            <p className="mt-2 mb-6 text-gray-800 leading-relaxed text-sm md:text-base">
              Download from Google Play and access our full suite of services anytime, anywhere.
            </p>
          </div>
          <a
            href="https://play.google.com/store"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-transform hover:scale-105 flex justify-center"
          >
            <img src={playStore} alt="Google Play" className="h-14 drop-shadow" />
          </a>
        </div>
      </div>

      <div className="w-full md:w-1/2 max-w-md">
        <div className="bg-white/90 border border-blue-50 rounded-3xl p-8 shadow-lg h-full flex flex-col justify-between">
          <div>
            <h2 className="text-xl md:text-4xl font-extrabold text-[#7b003f] mb-2 tracking-tight text-center">
              <span className="italic text-[#5c1a32]">Available on</span>{" "}
              <span className="text-[#7b003f]">App Store</span>
            </h2>
            <span className="inline-block text-xs font-bold bg-[#fde3ff] text-[#82045a] rounded-xl py-1 px-3 mt-2 mb-6">
              IOS Compatible
            </span>
            <p className="mt-2 mb-6 text-gray-800 leading-relaxed text-sm md:text-base">
              iPhone users can now download our official app from the App Store.
            </p>
          </div>
          <a
            href="https://www.apple.com/in/app-store/"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-transform hover:scale-105 flex justify-center"
          >
            <img src={appStore} alt="App Store" className="h-14 drop-shadow" />
          </a>
        </div>
      </div>
    </div>
  );
}
